import { leadCampaignKey } from 'utils/constants/queryKey'
import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import { getLeadCampaign, getLeadCampaignInfo } from 'services/lead-campaign'
import {
  GetLeadCampaignPayload,
  GetLeadCampaignResponse,
  GetLeadCampaignInfoResponse,
} from 'services/types/lead-campaign'

export const useCampaignList = (payload: GetLeadCampaignPayload, options?: AppQueryOptions<GetLeadCampaignResponse>) =>
  useAppQuery(leadCampaignKey.list(payload), () => getLeadCampaign(payload), options)

export const useCampaignDetail = (payload: string, options?: AppQueryOptions<GetLeadCampaignInfoResponse>) =>
  useAppQuery(leadCampaignKey.detail(payload), () => getLeadCampaignInfo(payload), options)
